import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
export function AdminRoute() {
    const { player, loading } = useAuth();
    if (loading)
        return _jsx("div", { className: "text-foreground-muted", children: "Loading\u2026" });
    if (!player)
        return _jsx(Navigate, { to: "/login", replace: true });
    if (!player.is_admin)
        return _jsx(Navigate, { to: "/", replace: true });
    return _jsx(Outlet, {});
}
